import React from "react";
import { useTranslation } from "react-i18next";
import ChartCardContainer from "./ChartCardContainer";
import GaugeChart from "./GaugeChart";
import RiskAssessmentChart from "./RiskAssementChart";
import WaterFillingChart from "./WaterFillingChart";
import { useMaterialAssessment } from "../../hooks";

export default function RiskRecycling({ materialCode }) {
    const { t } = useTranslation();
    // Fetch assessment data from API (contains all 3 metrics)
    const { data: assessment, loading, error } = useMaterialAssessment(materialCode);

    return (
        <ChartCardContainer title={t("charts.section.riskRecycling")}>
            <div className="risk-recycling-grid">
                {/* Commodity Necessity */}
                <div className="risk-card">
                    <GaugeChart
                        value={assessment?.commodity_necessity_value ?? 40}
                        title={t("charts.risk.commodityNecessity")}
                        description={assessment?.commodity_necessity_description ??
                            "Lithium is rated 90 out of 100 for its essentiality. It's critical for all modern electronics and the electric vehicle industry."}
                        loading={loading}
                        error={error}
                    />
                </div>

                {/* Risk Assessment */}
                <div className="risk-card">
                    <RiskAssessmentChart
                        percentage={assessment?.risk_assessment_value ?? 50}
                        title={t("charts.risk.riskAssessment")}
                        description={assessment?.risk_assessment_description ??
                            "Lithium is rated 90 out of 100 for its essentiality. It's critical for all modern electronics and the electric vehicle industry"}
                        loading={loading}
                        error={error}
                    />
                </div>

                {/* Recycling Rate */}
                <div className="risk-card">
                    <WaterFillingChart
                        percentage={assessment?.recycling_rate_value ?? 65}
                        title={t("charts.risk.recyclingRate")}
                        description={assessment?.recycling_rate_description ??
                            "Lithium is rated 90 out of 100 for its essentiality. It's critical for all modern electronics and the electric vehicle industry"}
                        loading={loading}
                        error={error}
                    />
                </div>
            </div>
        </ChartCardContainer>
    );
}
